<template>
	<div id="chaindetail" v-title :data-title="title + '-产业投资图谱'">
		<headerbar :curindex="curindex" v-if="userdata.userType > 1"></headerbar>
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="freeUserType" :bgtype="0" :isShowDownFile="true"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='!userdata.token || userdata.groupType != 1'>
				<div class="index_left_centerpage">
					<div class="chain-detail gov_chain-detail">
						<div class="chain_detai_top ">
							<div class="chain-title-box">
								<h2 class="chain-title oh">
									<div class="chain-title-sm fl">全国-{{ chaininformation.title }}</div>
									<div class="display-inline-block ml-4 font-18 font-normal">
										<vedioTips :type="2"></vedioTips>
									</div>
									<span class="enterprise-download fr" @click="downloadWord()"><i
											class="el-icon-download"></i>下载产业链分析报告</span>
									<span style="border-color: #3A568E;color: #3A568E;"
										:class="chaininformation.collectId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
										@click="collectFun()">{{ chaininformation.collectId == 0 ? '+添加关注' : '取消关注' }}</span>
								</h2>
								<div class="chain_top_infor">
									<div class="chain_classify">
										<div class="cc_show" v-html="chaininformation.category"></div>
									</div>
									<div class="fr poinNumber">共 <strong class="basefont">{{ chaininformation.nodeCount
											}}</strong>个产业节点， <strong class="basefont">{{ chaininformation.companyCount
											}}</strong> 家企业</div>
									<!--<div class="fr poinNumber">共 <strong class="basefont">30</strong>个产业节点，<strong class="basefont"> 6890</strong> 家企业</div>-->
									<div class="fr chainpoint">
										<span class="orangebd bdbox " :node="chaininformation.coreNode"
											onclick="keychainpoint(this,'#f60')">核心节点</span>
										<span class="greenbd bdbox " :node="chaininformation.subChain"
											:idlist="chaininformation.subChainId"
											onclick="keychainpoint(this,'#238e83')">子产业链</span>
									</div>
								</div>
							</div>
							<!--放置产业链内容处 <div id="chain-con"><img src="/public/imagesv2/chaindetail.png" /></div>-->
							<div class="chain-graph-wrap">
								<chain ref="chain" :graphData="chaininformation.graphData"
									:nodelistprops="nodelistpropss" v-if="flag"></chain>
								<div class="chain_inportant_company">
									<h4 class="title">重点公司</h4>
									<div class="box">
										<div class="botcompanybox oh">
											<a href="/company/detail/700167" target="_blank"
												class="company_name">上海九院</a>
											<a href="/company/detail/703062" target="_blank"
												class="company_name">大连市第三人民医院</a>
											<a href="/company/detail/703277" target="_blank"
												class="company_name">北京大学第三医院</a>
											<a href="/company/detail/703496" target="_blank"
												class="company_name">北京协和医院</a>
											<a href="/company/detail/703497" target="_blank"
												class="company_name">北京中医医院</a>
											<a href="/company/detail/705389" target="_blank"
												class="company_name">北京华信医院</a>
											<a href="/company/detail/705992" target="_blank"
												class="company_name">天津医科大附属医院</a>
											<a href="/company/detail/708308" target="_blank"
												class="company_name">中国解放军总院</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- TODO -->
						<div class="chain_RelatedReport" v-show="reportList.length > 0">
							<h2 class="chain_title2">相关产业链</h2>
							<ul class="chain_rReport chain_rReport2">
								<li :key="i" v-for="(list, i) in chainCategoryList" @click="chainrouter1(list.chainId)">
									<i></i><span class="hovercolor cur-pointer">{{ list.chainName }}</span>
								</li>
							</ul>
						</div>
						<div class="chain_RelatedReport" v-show="reportList.length > 0">
							<h2 class="chain_title2">相关报告</h2>
							<ul class="chain_rReport">
								<li :key="i" v-for="(list, i) in reportList" v-if="i < 8" :data="list.id"><i></i><a
										target="_blank" :href="list.url + '&token=' + userdata.token">{{ list.title
										}}</a></li>
								<li><a class="redfont" target="_blank"
										:href="chaininformation.moreReport + '&token=' + userdata.token">更多相关报告></a>
								</li>
							</ul>
						</div>
						<!-- 产业生命周期 -->
						<lifeCircle :lifeCircleNodeList='lifeCircleNodeList' :chaininformation="chaininformation"
							v-if="lifeCircleNodeList.length > 0"></lifeCircle>
						<!-- 拿地项目 -->
						<land :userdata="userdata" :landList="landList" :title="chaininformation.title"
							v-if="landList.length > 0"></land>
						<!-- 投资项目 -->
						<invest :userdata="userdata" :investList="investList" :title="chaininformation.title"
							v-if="investList.length > 0"></invest>
						<!-- 相关产业库数据 -->
						<industry :industryList="industryList" :title="chaininformation.title"
							:baseInfo="chaininformation" v-if="industryList.length > 0"></industry>
						<!-- 市场规模 -->
						<market :userdata="userdata" :baseInfo="chaininformation" :marketList="marketList"
							v-if="marketList.length > 0"></market>
						<!-- 竞争格局 -->
						<competitive :userdata="userdata" :baseInfo="chaininformation"
							:competitiveList="competitiveList" v-if="competitiveList.length > 0"></competitive>
						<div class="chain_map" v-show="mapdata.length != 0">
							<h2 class="chain_title1">全国{{ chaininformation.title }}地图</h2>
							<div class="poabox">
								<chainMap :mapdata="mapdata" v-if="flag" :leftNumber="'65%'"></chainMap>
							</div>
							<!-- <h4 class="title chain_map_title fl">全国{{ chaininformation.title }}地图</h4> -->
							<div v-html="chaininformation.nodeMap"></div>
						</div>
						<!-- <div id="chain_banner_lian"> 
		<div class="lian_banner">
				<div class="chain_banner_font">
					<h2 class="title title1">产业链精准招商图谱</h2>
					<h3 class="title2">提供 <strong class="yellfont">“营商环境分析”+“竞争情报分析”+“产业招商图谱”</strong>的精准服务</h3>
					<p class="font3">摸清产业发展概况 / 确定核心重点产业 / 找准产业链中的位置<br>明确产业发展路径 / 找到产业招商对象</p>
					<a href="http://c.ocn.com.cn/special/industryAtlas/" class="knowmore" target="_blank">了解更多</a>
				</div>
					</div>
		</div> -->
						<!-- <div class="chain_report" v-show="chaininformation.report!=''">
			<h3 class="title">相关报告</h3>
			<ul class="oh chain_table" v-html="chaininformation.report"></ul>
		</div> -->
						<!-- 	<div class="chain_detail_bot"  v-if="chaininformation.importantCompany!=''" v-show="id!=253">  20230612要求隐藏
				<div class="chain_table_box">
					<h2 class="chain_title1">产业链重点公司</h2>
					<table border="0" cellspacing="0" cellpadding="0" class="industry-point-table chain_table companies_key">
						<tr style="background: rgb(248, 251, 254);">
							<th><span>企业名称</span></th> 
							<th><span>类型</span></th>
							<th><span>行业地位</span></th>
							<th><span class_="tablesort {$fzjieduan}" data="fzjieduan">发展阶段<i></i></span></th>
							<th><span class_="tablesort {$jyzhuangkuang}" data="jyzhuangkuang">经营状况<i></i></span></th>
							<th><span class_="tablesort {$jingzhengli}" data="jingzhengli">竞争力<i></i></span></th>
							<th><span class_="tablesort {$chengzhangxing}" data="chengzhangxing">成长性<i></i></span></th>
							<th><span class_="tablesort {$tzyiyuan}" data="tzyiyuan">投资意愿<i></i></span></th>
							<th><span class_="tablesort {$tznengli}" data="tznengli">投资能力<i></i></span></th>
							<th><span class_="tablesort {$zsjihui}" data="zsjihui">招商机会<i></i></span></th>
							<th><span>城市选择</span></th>
							<th><span>片区选择</span></th>
						</tr>
						<tbody v-html="chaininformation.importantCompany"></tbody>
					</table> 
				</div>
		</div> -->
						<div class="chain_detail_bot">
							<div class="chain_table_box">
								<h2 class="chain_title1" v-show="chaininformation.companyList != ''">产业链各细分领域公司
									<span class="bluefont" v-if="!userdata.token && id != 44">（注：此处仅展示一个产业链节点）</span>
								</h2>
								<table border="0" cellspacing="0" cellpadding="0" class="chain_table centerpage1"
									v-show="chaininformation.companyList != ''">
									<!-- 该备注文字可删除  data-market是放在对应节点名称的第一个tr上 例如 <tr class="node-5234" style="background: rgb(252, 253, 255);" data-market='[{"name":"市场规模","data":[{"name":"2019","datay":"130~250亿元"},{"name":"2020","datay":"180~340亿元"}]},{"name":"市场机会评估","data":[{"name":"市场潜力","datay":"中等"},{"name":"发展阶段","datay":"成长期"},{"name":"机会属性","datay":"中等"},{"name":"政策门槛","datay":"一般"},{"name":"竞争门槛","datay":"较高"},{"name":"技术门槛","datay":"中等"},{"name":"资金门槛","datay":"较高"}]},{"name":"招商机会分析","data":[{"name":"适合区域","datay":"一、二、三、四线城市"},{"name":"招商时机","datay":"一般"},{"name":"推荐程度","datay":"适中"}]}]'>-->
									<!-- 该备注文字可删除  如果后台没有设置data-market的属性时，data-market="", 当鼠标移上节点时显示节点重点公司内容  -->
									<tbody v-html="chaininformation.companyList"> </tbody>
								</table>
								<!-- 版权为深圳市中投顾问股份有限公司所有， -->
								<p class="chain_footer"><em class="redfont">*</em> 本内容已申请TSA数字版权保护，未经授权，不得转载！
								</p>
							</div>
						</div>
					</div>
				</div>
			</watermark>

		</div>
	</div>
</template>

<script>
import $ from "jquery";
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import lifeCircle from "@/components/inc/chainLifeCycle.vue"
import land from './chaindetail-inc/land.vue'
import invest from './chaindetail-inc/invest.vue'
import industry from './chaindetail-inc/industry.vue'
import market from './chaindetail-inc/market.vue'
import competitive from './chaindetail-inc/competitive.vue'

import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'chaindetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	components: {
		freeUserTips, lifeCircle, land, invest, industry, competitive, market
	},
	data() {
		return {
			id: 0,
			chaininformation: { collectId: 0 },
			curindex: 1, nodelistpropss: [],
			userdata: {}, curWebsite: this.$api.getWebsiteType(),
			flag: false, //echarts渲染的开关
			mapdata: [],
			companyCount: '',
			nodeCount: '',
			coreNode: '',
			subChain: '',
			subChainId: '',
			companyList: '',
			title: "",
			graphData: '',
			importantCompany: '', reportList: [],
			nodeMap: '',
			nodeScoreTable: '',
			provinceMap: [],
			showSubChain: false,
			sTitle: '',
			report: '',
			category: '',
			chainCategoryList: [],
			isShowFreeUserTips: false,
			freeUserType: 2,
			lifeCircleNodeList: [],
			landList: [],
			investList: [],
			industryList: [],
			marketList: [],
			competitiveList: []
		}
	},
	beforeCreate() {
		// console.log('beforeCreate');

	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
	},
	mounted() {
		// if(this.curWebsite.type == 4){
		// 	this.marketTitle1='重要市场机会点'; 
		// }else if(this.curWebsite.type == 2){
		// 	this.marketTitle1='重要投资机会点';
		// }else{
		// this.marketTitle1='重要招商机会点';
		// } 
		this.getuserinfor();
		this.bus.$emit('loading', true);
		let ddd = false;
		if (this.userdata.edition < 1) {
			var that = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				that.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.loadData();
		var that = this;
		$('.mx-shape-node').hover(function (i, el) {
			var nodeids = $(this).attr('node');
			that.chainFixedBox(nodeids, this);
		}, function () {
			$('.chain_inportant_company').hide();
		})
		$('.chain_inportant_company').hover(function () {
			$(this).show();
		}, function () {
			$(this).fadeOut();
		})
		// that.keychainpoint('.chainpoint .orangebd', '#f60');
		// that.keychainpoint('.chainpoint .greenbd', '#238e83');
	},
	methods: {
		// 获取市场竞争列表
		getMarketList(type) {
			this.bus.$emit('loading', true);
			var _this = this;
			let notionCode = this.chaininformation.notionList;
			let ajaxUrl = this.$api.free.market.mergeList() + '?notionList=' + notionCode;
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log(ajaxUrl, res);
				if (res.data.success) {
					console.log(type == 1 ? '市场规模列表' : '竞争格局列表', res.data);
					let data = res.data.data;
					// data = data.filter((list,i) => {
					// 	return i<6;
					// })
					if (type == 1) {
						_this.marketList = data.market;
					} else {
						_this.competitiveList = data.compete;
					}
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});

		},
		downloadWord() {
			if (this.userdata.isFree || (this.userdata.groupType == 0 && !this.chaininformation.download)) { //免费无下载权限，试用账号需要授权download才能下载，产业链权限弹窗提示
				this.freeUserType = 2;
				this.isShowFreeUserTips = true;
				return;
			} else if (this.userdata.groupType == 1 && !this.chaininformation.download) {//正式账号无下载产业链权限弹窗提示
				this.freeUserType = 3;
				this.isShowFreeUserTips = true;
				return;
			}
			var that = this;
			var fileName = this.chaininformation.title + '.docx';
			try {
				//1请求后台获取文档流
				that.bus.$emit('loading', true);
				this.$axios.get(this.$api.cyl.chain.download() + '?chainId=' + this.id, {
					headers: {
						AuthToken: this.userdata.token
					},
					responseType: 'blob',//*响应类型需要是blob
				}).then(function (res) {
					console.log('后端返回的文档流', res)
					const blob = res.data;
					console.log(blob)
					//2 创建一个url 对象，并将blob实例作为参数传入，这样href的值就是以blob开头的一个文件流下载链接
					const url = window.URL.createObjectURL(blob);
					console.log(url);
					//3创建下载链接
					const a = document.createElement('a');
					a.href = url;
					a.download = fileName || Date.now();
					a.style.display = 'none';
					a.click();
					//4避免占用销毁创建的链接
					document.body.removeChild(a)

				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			} catch (error) {
				console.error('Error:', error);
			} finally {
				that.bus.$emit('loading', false);
			}


		},
		MainScopeShowMore() {
			$('.chain-table-main-scope').each(function () {
				var fontlength = $(this).html().length;
				$(this).attr('data-num', fontlength);
				if (fontlength > 134) {
					$(this).prepend('<span class="showmorebtn">更多文字信息……</span>')
				}
			});
			$('.showmorebtn').click(function () {
				$(this).parent('.chain-table-main-scope').toggleClass('showmore');
			})
		},
		getuserinfor() {
			this.userdata = this.getuseriformation();
			if (this.userdata.userType > 1) {
				this.curindex = 2;
			}
		},
		//获取产业链详情第一部分信息
		loadData() {
			//this.id = this.$route
			this.id = this.$route.query.id;
			var that = this;
			if (!this.id) {
				return;
			}
			//获取产业链详情信息
			this.$axios.get(this.$api.cyl.chain.get() + '?chainId=' + this.id, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					let datar = res.data.data;
					console.log('chaininfomation', res.data);
					that.chainCategoryList = res.data.list;
					that.chaininformation = datar;
					that.chaininformation.companyList = '<tr><th style="line-height:48px;">细分领域</th><th>企业名称</th><th>注册资本</th><th>所属城市</th><th style="width:220px">详细地址</th><th style="width:500px">经营范围</th></tr>' + datar.companyList;
					that.reportList = datar.reportList;
					document.title = datar.title;
					that.mapdata = JSON.parse(datar.provinceMap);
					that.lifeCircleNodeList = JSON.parse(datar.lifeCircle.nodeList);
					// console.log(that.lifeCircleNodeList);
					if (datar.provinceMap.length != 0) {
						that.flag = true;
					}
					that.loadData2();
					that.getMarketList(1);
					that.getMarketList(2);
					setTimeout(() => {
						that.stargradef();
						that.MainScopeShowMore();
					}, 1000);
					// that.stargradef(); 
				} else {
					that.isShowFreeUserTips = true;
					that.bus.$emit('loading', false);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取产业链第二部分信息
		loadData2() {
			this.id = this.$route.query.id;
			var that = this;
			if (!this.id) {
				return;
			}
			//获取产业链详情信息
			this.$axios.get(this.$api.cyl.chain.detail2() + '?chainId=' + this.id, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					let datar = res.data.data;
					console.log('chaininfomation2', res.data);
					that.landList = res.data.data.land;
					that.investList = res.data.data.invest;
					that.industryList = res.data.data.industry;
					console.log(typeof that.industryList, typeof that.investList);
				}
				that.bus.$emit('loading', false);
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		stargradef(el) {
			var lengs = document.getElementsByClassName('stargrade').length;
			for (var d = 0; d < lengs; d++) {
				var starnum = document.getElementsByClassName('stargrade')[d].getAttribute('data') * 1;
				var graynum = 4 - starnum;
				let html1 = "", html2 = "";
				for (var i = 0; i < starnum; i++) {
					html1 += '<i class="starfull"></i>';
				}
				for (var i = 0; i < graynum; i++) {
					html2 += '<i class="stargray"></i>';
				}
				document.getElementsByClassName('stargrade')[d].innerHTML = html1 + html2;
			}
		},
		keychainpoint(obj, color) {
			$(obj).toggleClass('current');
			var nodeList = $(obj).attr("node").split(','),
				showgreen = $(obj).hasClass('current');
			if (showgreen) {
				gv.setColor(nodeList, '#fff', color, color); //文字颜色，背景色，边框色
			} else {
				gv.setColor(nodeList); //恢复
			}
		},
		//添加删除收藏
		// collectFun(){
		// 	// console.log(this.companyinfor.collectId,this.companyinfor);
		// 	this.listToggleCollect(this.chaininformation,'acoc') 
		// },
		collectFun() {
			console.log(this.chaininformation.collectId, this.chaininformation.collectType);
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			var that = this, cid = this.chaininformation.collectId;
			var ajaxurl = "", ajaxdata = {};
			if (cid == 0) {
				ajaxurl = this.$api.cyl.collect.add();
				ajaxdata = { type: this.chaininformation.collectType, id: this.id }
			} else {
				ajaxurl = this.$api.cyl.collect.remove();
				ajaxdata = { collectId: this.chaininformation.collectId };
			}
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: ajaxdata,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					if (res.success) {
						if (cid == 0) {
							that.chaininformation.collectId = res.data.collectId;
						} else {
							that.chaininformation.collectId = 0;
						}
					}
				}
			})
		}
	}




}
</script>

<style lang="scss">
/* @import url("../../assets/css/chaindetaill.css"); */
/* @import url("/css/common-chian.css"); */

#app {
	height: auto !important;
}


.chain_title1 {
	.bluefont {
		font-size: 18px;
		font-weight: normal;
	}
}
</style>
